<script lang="ts" setup>
	const showDialog = defineModel<boolean>('show', { default: true })
	const emit = defineEmits<{
		(e: 'open-coverage'): void
	}>()
</script>
<template>
	<dialogs v-model:show="showDialog" modal-class="max-w-[600px]">
		<template #title>
			<h2 class="mt-[90px] text-center text-3xl font-semibold leading-9 text-sky-900">
				Coverage Option Unavailable
			</h2>
		</template>
		<template #default>
			<div class="flex w-full flex-col justify-center gap-y-[85px]">
				<div class="mx-auto w-full max-w-[450px] text-center text-base leading-6 text-slate-600">
					The coverage period <span class="font-semibold">( Yearly )</span> for this plan isn't available at
					the moment. You can continue by choosing the longest available coverage option for this plan.
				</div>
				<ui-button
					text="Continue with recommended coverage"
					class="mx-auto w-full max-w-[450px] justify-center"
					@click="emit('open-coverage')"
				/>
			</div>
		</template>
	</dialogs>
</template>
